import React from 'react';
import { Check, Icon, IconWeight } from 'phosphor-react';

interface QuizOption {
  value: string;
  label: string;
  icon?: Icon;
  iconWeight?: IconWeight;
  description?: string;
}

interface QuizOptionCardProps {
  option: QuizOption;
  isSelected: boolean;
  onSelect: (value: string) => void;
  /** Lista longa em duas colunas: cartão mais baixo e sem o selo — a borda já marca a escolha. */
  compact?: boolean;
}

export default function QuizOptionCard({ option, isSelected, onSelect, compact = false }: QuizOptionCardProps) {
  const IconComponent = option.icon;

  return (
    <button
      onClick={() => onSelect(option.value)}
      className={`
        w-full text-left rounded-2xl border-2 transition-colors duration-300 ease-soft ${compact ? 'p-3' : 'p-4'}
        ${isSelected
          ? 'border-blush-300 bg-blush-50 dark:bg-blush-900/20 shadow-glow-blush'
          : 'border-transparent bg-white dark:bg-gray-800 shadow-soft hover:border-blush-100 hover:shadow-soft-md dark:hover:bg-gray-700'
        }
        active:scale-[0.97]
      `}
    >
      <div className="flex items-center gap-3">
        {IconComponent && (
          <span className={`flex-shrink-0 ${isSelected ? 'text-blush-500 dark:text-blush-300' : 'text-nude-400 dark:text-gray-400'}`}>
            <IconComponent size={compact ? 20 : 22} weight={option.iconWeight} />
          </span>
        )}
        <div className="flex-1 min-w-0">
          <p className={`text-sm font-semibold ${isSelected ? 'text-blush-700 dark:text-blush-300' : 'text-gray-700 dark:text-gray-200'}`}>
            {option.label}
          </p>
          {option.description && (
            <p className={`text-xs text-nude-500 dark:text-gray-400 mt-0.5 ${compact ? 'line-clamp-2' : ''}`}>
              {option.description}
            </p>
          )}
        </div>
        {isSelected && !compact && (
          <div className="animate-scale-in w-6 h-6 bg-blush-500 rounded-full flex items-center justify-center">
            <Check className="w-3.5 h-3.5 text-white" />
          </div>
        )}
      </div>
    </button>
  );
}
